<template>
  <div>
      <navbar/>
      <div class="container-fluid">
        <h3>Detalle Cuentas</h3>
        <button @click="actualizar">Actualizar</button>
        <router-link style="float: right" :to="{ name: 'notas', params: { id: this.$route.params.id, tipo: 'cuentas' }}" class="linkRefnum">Notas</router-link>
        <router-link style="float: right" :to="{ name: 'archivos', params: { id: this.$route.params.id, tipo: 'cuentas' }}" class="linkRefnum">Archivos | </router-link>
        <div class="row">
            <div class="col-md-6 ">
                Identificador: 
                <input class="form-control" v-model="oneCuenta.identificador">
            </div>
            <div class="col-md-6 ">
                Razón social: 
                <input class="form-control" v-model="oneCuenta.razonsocial">
            </div>
        </div>

        <div class="row">
            <div class="col-md-6 ">
                Giro:
                <input class="form-control" v-model="oneCuenta.giro">
            </div>
            <div class="col-md-6 ">
                Acuerdo:
                <select class="form-control" v-model="oneCuenta.idsla">
                    <option v-for="item in allAcuerdos" :key="item.id" :value="item.id">{{item.nombre}}</option>
                </select>
            </div>
        </div>

        <div class="row">
            <div class="col-md-6 ">
                Representante:
                <select class="form-control" v-model="oneCuenta.idrepresentante">
                    <option v-for="item in allContacto" :key="item.id" :value="item.id">{{item.nombre}}</option>
                </select>
            </div>
            <div class="col-md-6 ">
                Dirección:
                <input class="form-control" v-model="oneCuenta.direccion">
            </div>
        </div>

        <div class="row">
            <div class="col-md-6 ">
                Email:
                <input class="form-control" v-model="oneCuenta.correo">
            </div>
            <div class="col-md-6 ">
                Teléfono:
                <input class="form-control" v-model="oneCuenta.telefono">
            </div>
        </div>

        <h3>Redes Sociales</h3>
        <div class="row">
            <div class="col-md-6">
                Página:
                <input class="form-control" v-model="oneCuenta.paginaweb">
            </div>
            <div class="col-md-6">
                Facebook:
                <input class="form-control" v-model="oneCuenta.facebook">
            </div>
        </div>
        <div class="row">
            <div class="col-md-6">
                Twitter:
                <input class="form-control" v-model="oneCuenta.twitter">
            </div>
            <div class="col-md-6">
                Instagram:
                <input class="form-control" v-model="oneCuenta.instagram">
            </div>
        </div>

        <div class="row mt-3">
            <div class="col-md-4 ">
                <h3>Campos Personalizados:</h3>
                <div v-for="cf  in allCfs" :key="cf.id">
                    <p>{{cf.nombre}}</p>
                    <input class="form-control" v-model="normalizedValue[cf.nombre]">
                </div>
                
            </div>
            {{contactsOfCuenta.grupocontactos}}
            <!-- <div class="col-md-8 ">
                <h3>Contactos:</h3>
                <cuentacontacto tipo="contacto"></cuentacontacto>
            </div> -->
        </div> 
    </div>
  </div>
</template>

<script>
import { log } from 'util'
import { mapState, mapMutations, mapGetters, mapActions } from 'vuex'
export default {
   components: {
        navbar: () => import('@/views/Agente/navBar.vue'),
        cuentacontacto: () => import('@/views/Agente/CuentaContacto.vue')
    },
    data(){
        return{
            cfs: {}
        }
    },
    computed:{
         ...mapGetters('validatetoken', { 
            oneCuenta: 'oneCuenta',
            allAcuerdos: 'allAcuerdos',
            allContacto: 'allContacto',
            allCfs: 'allCfs',
            contactsOfCuenta: 'contactsOfCuenta'
          
        }),
        idCuenta(){
            return {
                id: this.$route.params.id,
                method: ['cfs', 'acuerdos']
            } 
        },
        normalizedValue: {
            get() {
                if (this.oneCuenta.cf === undefined || this.oneCuenta.cf === null) {
                    return {}
                }
                Object.keys(this.oneCuenta.cf).forEach(key => {
                    if (this.oneCuenta.cf[key] === '') {
                        this.oneCuenta.cf[key] = null
                        // delete this.value[key]
                    }
                })
                return this.oneCuenta.cf
            },
            set(data) {
                this.$emit('input', data)
            }
        }
    },
    methods:{
        ...mapActions('validatetoken', {
            getByCuenta: 'getByCuenta',
            getAllAcuerdo: 'getAllAcuerdo',
            getContacto: 'getContacto',
            getAllCfs: 'getAllCfs',
            saveCuenta: 'saveCuenta',
            getContacts: 'getContacts'
        }),
        getAll(){

            //tengo que llamar a los contactos
            Promise.all([
                this.getByCuenta(this.idCuenta),
                // this.getAllAcuerdo(),
                // this.getAllCfs({ idtipoobjeto: 3 })
            ])
            .then(()=>{
                this.getContacts({
                    id: this.oneCuenta.id,
                    pagina: 1,
                    cantidad: 10
                })
                .then((data)=>{
                    this.$store.commit('validatetoken/setAllContactoCuenta', data.data)
                })
            })
        },
        actualizar(){
            this.saveCuenta()
        },
   
    },
    created() {
        this.getAll()
    },
}
</script>

<style>

</style>